/* ============================================================
   Good Aussie Stuff — theme JavaScript
   Mobile nav, AJAX cart drawer, add-to-cart, cart page,
   back-to-top, announcement-bar auto-hide.
   ============================================================ */

/* ── Mobile nav ── */
function toggleMobileNav() {
  document.querySelector('.mobile-nav-btn').classList.toggle('active');
  document.querySelector('.mobile-nav-overlay').classList.toggle('active');
  document.querySelector('.mobile-nav-panel').classList.toggle('active');
  document.body.style.overflow = document.querySelector('.mobile-nav-panel').classList.contains('active') ? 'hidden' : '';
}

/* ── Cart drawer open/close ── */
function toggleCartDrawer() {
  document.querySelector('.cart-drawer-overlay').classList.toggle('active');
  document.querySelector('.cart-drawer').classList.toggle('active');
  document.body.style.overflow = document.querySelector('.cart-drawer').classList.contains('active') ? 'hidden' : '';
}

function openCartDrawer() {
  document.querySelector('.cart-drawer-overlay').classList.add('active');
  document.querySelector('.cart-drawer').classList.add('active');
  document.body.style.overflow = 'hidden';
}

/* ── Add to cart (AJAX → open drawer) ── */
function addToCart(variantId, qty) {
  if (!variantId) return;
  const btn = document.getElementById('gasAdd');
  const original = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
    .then(r => r.json())
    .then(() => fetch('/cart.js'))
    .then(r => r.json())
    .then(cart => {
      renderCartDrawer(cart);
      openCartDrawer();
      showCartToast();
    })
    .catch(err => console.error('Add to cart failed:', err))
    .finally(() => { if (btn) { btn.disabled = false; btn.textContent = original; } });
}

function showCartToast() {
  const toast = document.getElementById('cart-toast');
  if (!toast) return;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 2000);
}

/* ── Cart drawer item quantity (re-renders drawer) ── */
function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then(r => r.json())
    .then(cart => { renderCartDrawer(cart); })
    .catch(err => console.error('Cart update failed:', err));
}

/* ── Cart PAGE item quantity (full reload) ── */
function updateCartPageItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then(r => r.json())
    .then(() => { window.location.reload(); })
    .catch(err => console.error('Cart update failed:', err));
}

function renderCartDrawer(cart) {
  const body = document.querySelector('.cart-drawer-body');
  const footer = document.querySelector('.cart-drawer-footer');
  const cartBtn = document.querySelector('.cart-text');

  if (cartBtn) cartBtn.textContent = 'Cart (' + cart.item_count + ')';

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>Your cart is empty</p></div>';
    footer.innerHTML = '<button onclick="toggleCartDrawer()">Continue Shopping</button>';
    return;
  }

  let html = '';
  cart.items.forEach(function(item) {
    const displayTitle = item.product_title.split(' – ')[0];
    const variantTitle = item.variant_title || '';
    const imgTag = item.image ? '<img src="' + getSizedImageUrl(item.image, '80x80') + '" alt="' + displayTitle.replace(/"/g, '&quot;') + '" width="80" height="80">' : '';
    const price = formatMoney(item.final_line_price);

    html += '<div class="cart-item" data-cart-item-key="' + item.key + '">';
    html += imgTag;
    html += '<div class="cart-item-details">';
    html += '<a href="' + item.url + '">' + displayTitle + '</a>';
    if (variantTitle && variantTitle !== 'Default Title') {
      html += '<span>' + variantTitle + '</span>';
    }
    html += '<div class="cart-item-bottom">';
    html += '<div class="cart-item-qty">';
    html += '<button class="cart-qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease quantity">−</button>';
    html += '<span class="cart-qty-num">' + item.quantity + '</span>';
    html += '<button class="cart-qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>';
    html += '</div>';
    html += '<span class="cart-item-price">' + price + '</span>';
    html += '<button class="cart-item-remove" onclick="updateCartItem(\'' + item.key + '\', 0)" aria-label="Remove item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
    html += '</div></div></div>';
  });

  body.innerHTML = html;

  const totalPrice = formatMoney(cart.total_price);
  footer.innerHTML = '<div style="display:flex;justify-content:space-between;margin-bottom:12px;font-weight:600;"><span>Subtotal</span><span>' + totalPrice + '  USD</span></div><a href="/checkout" style="display:block;text-align:center;background:var(--eucalyptus);color:#fff;padding:14px;border-radius:var(--radius-sm);font-family:\'Hanken Grotesk\',sans-serif;font-weight:600;text-transform:uppercase;letter-spacing:1px;text-decoration:none;">Checkout</a>';
}

function getSizedImageUrl(url, size) {
  if (!url) return '';
  const match = url.match(/(.+)\.(jpg|jpeg|png|gif|webp)/i);
  if (match) return match[1] + '_' + size + '.' + match[2];
  return url;
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ── Scroll: announcement-bar auto-hide + back-to-top ── */
(function() {
  const ann = document.querySelector('.announcement-bar');
  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    if (ann) {
      if (scrollY > 80) { ann.classList.add('hidden'); }
      else { ann.classList.remove('hidden'); }
    }
    const btt = document.getElementById('backToTop');
    if (btt) {
      if (scrollY > 600) { btt.classList.add('visible'); }
      else { btt.classList.remove('visible'); }
    }
  }, { passive: true });
})();
